/**
 * Uzbek strings of the AI agent's files screen (§6A.2, §17.12). Spread into `uz`, so a key here is
 * a `TranslationKey` like any other.
 */
export const uzAiFiles = {
  "aiFiles.title": "Fayllar",
  "aiFiles.intro":
    "AI shu fayllardagi ko'rsatmalar bilan ishlaydi. Saqlash qoralamaga yoziladi: nashr qilinmaguncha javoblarga ta'sir qilmaydi.",
  "aiFiles.noPermission": "Bu bo'limni faqat agentlik egasi va menejerlar ko'radi.",
  "aiFiles.retry": "Qayta urinish",
  "aiFiles.list": "Agent fayllari",
  "aiFiles.group.jobs": "Vazifa fayllari",
  "aiFiles.group.shared": "Umumiy fayllar",
  "aiFiles.changed": "O'zgargan",
  "aiFiles.unsaved": "Saqlanmagan",
  "aiFiles.source.draft": "v{number} · qoralama",
  "aiFiles.source.published": "v{number} · nashr qilingan",
  "aiFiles.source.archived": "v{number} · arxiv",
  "aiFiles.source.none": "Sozlama hali yo'q",
  "aiFiles.source.knowledge": "Bilim bazasidan",
  "aiFiles.draftNotice": "Qoralama v{number}: {count} ta fayl o'zgargan.",
  "aiFiles.toPublish": "Nashr qilish sahifasiga o'tish",
  "aiFiles.mode.label": "Fayl ko'rinishi",
  "aiFiles.mode.edit": "Muharrir",
  "aiFiles.mode.merged": "Birlashgan ko'rinish",
  "aiFiles.mode.history": "Versiyalar",
  "aiFiles.editor.label": "{title} mazmuni",
  "aiFiles.editor.json": "Bu fayl JSON ko'rinishida saqlanadi.",
  "aiFiles.editor.formHint": "Ohang va iboralarning qulay shakli",
  "aiFiles.editor.invalidJson": "JSON yaroqsiz, fayl yuborilmadi. Qavslar va qo'shtirnoqlarni tekshiring.",
  "aiFiles.save": "Saqlash",
  "aiFiles.cancel": "Bekor qilish",
  "aiFiles.saved": "Qoralamaga saqlandi. Nashr qilinmaguncha javoblarga ta'sir qilmaydi.",
  "aiFiles.warnings.title": "Ogohlantirishlar",
  "aiFiles.warnings.hint":
    "Matn saqlanadi va modelga yetadi, lekin qoidaga zid javobni platforma baribir mijozga yubormaydi.",
  "aiFiles.merged.task": "Vazifa",
  "aiFiles.merged.noTask": "Vazifasiz",
  "aiFiles.merged.channel": "Kanal",
  "aiFiles.merged.noChannel": "Oddiy xabar",
  "aiFiles.merged.comment": "Instagram izoh",
  "aiFiles.merged.layers": "Qatlamlar: {layers}",
  "aiFiles.merged.draftNote": "Qoralama bo'yicha: nashr qilingandan keyin agent shuni o'qiydi.",
  "aiFiles.merged.liveNote": "Agent hozir shuni o'qiydi.",
  "aiFiles.merged.unsavedNote": "Saqlanmagan o'zgarishlar bu yerda ko'rinmaydi.",
  "aiFiles.layer.platform": "Platforma",
  "aiFiles.layer.agency": "Agentlik",
  "aiFiles.layer.task": "Vazifa",
  "aiFiles.layer.branch": "Filial",
  "aiFiles.layer.channel": "Kanal",
  "aiFiles.history.list": "Fayl versiyalari",
  "aiFiles.history.empty": "Bu fayl uchun versiya yo'q.",
  "aiFiles.history.current": "joriy",
  "aiFiles.history.draft": "qoralama",
  "aiFiles.history.changedHere": "Shu versiyada o'zgargan",
  "aiFiles.history.absent": "Bu versiyada bu fayl yo'q",
  "aiFiles.history.restore": "v{number} versiyasiga qaytarish",
  "aiFiles.history.confirmTitle": "v{number} versiyasiga qaytarish",
  "aiFiles.history.confirmBody":
    "Qoralamadagi «{title}» fayli v{number} mazmuni bilan almashtiriladi. Boshqa fayllarga tegilmaydi va hech narsa nashr qilinmaydi.",
  "aiFiles.history.restored": "Fayl qoralamaga qaytarildi.",
  "aiPublish.label": "Qoralamani nashr qilish",
  "aiPublish.notice": "Qoralama v{number} hali nashr qilinmagan.",
  "aiPublish.action": "Nashr qilish",
  "aiPublish.done": "Qoralama nashr qilindi",
  "aiPublish.toTests": "Sinov markazi",
} as const;
